/**
 * Created by Ray on 2017/11/6.
 */

import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ProgressService {

    private subject = new Subject<any>();
    indexes = 0;


    startProgress() {
        this.changeProgress(true);
    }

    finishProgress() {
        this.changeProgress(false);
    }

    changeProgress(status:boolean) {

        if (status) {
            this.indexes += 1;
        } else {
            this.indexes -= 1;
        }

        this.subject.next(this.indexes > 0);
    }

    clearProgress() {
        this.subject.next();
    }

    getProgress():Observable<boolean> {
        return this.subject.asObservable();
    }

}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/service/progress.service.ts